// Simplified Singapore coastline [lng, lat], from URA Master Plan 2025 boundaries (data.gov.sg)

export const MAINLAND = [
  [103.714, 1.29124], [103.725, 1.28956], [103.74, 1.27285], [103.726, 1.27161],
  [103.734, 1.26626], [103.723, 1.25988], [103.706, 1.26835], [103.714, 1.25902],
  [103.694, 1.25026], [103.685, 1.2684], [103.68, 1.26306], [103.69, 1.24003],
  [103.672, 1.22271], [103.671, 1.22369], [103.67, 1.22838], [103.672, 1.22358],
  [103.677, 1.22875], [103.663, 1.24498], [103.654, 1.27291], [103.691, 1.2913],
  [103.697, 1.29066], [103.684, 1.27653], [103.688, 1.27275], [103.696, 1.27689],
  [103.704, 1.29089], [103.712, 1.2916], [103.711, 1.30724], [103.702, 1.30184],
  [103.695, 1.30795], [103.699, 1.29953], [103.695, 1.30786], [103.694, 1.30094],
  [103.684, 1.29907], [103.681, 1.30918], [103.678, 1.29661], [103.669, 1.30632],
  [103.674, 1.29544], [103.667, 1.28868], [103.65, 1.30169], [103.656, 1.31147],
  [103.645, 1.30078], [103.65, 1.28352], [103.64, 1.27908], [103.643, 1.26085],
  [103.617, 1.26085], [103.617, 1.25398], [103.644, 1.25398], [103.644, 1.24796],
  [103.638, 1.24503], [103.617, 1.24503], [103.617, 1.23815], [103.65, 1.23815],
  [103.65, 1.2292], [103.617, 1.2292], [103.617, 1.2216], [103.657, 1.22161],
  [103.659, 1.21717], [103.642, 1.21024], [103.607, 1.22063], [103.606, 1.24368],
  [103.612, 1.24639], [103.606, 1.26113], [103.61, 1.26113], [103.611, 1.27633],
  [103.62, 1.28449], [103.617, 1.29409], [103.618, 1.29673], [103.627, 1.3183],
  [103.623, 1.31405], [103.621, 1.31968], [103.634, 1.33782], [103.633, 1.3508],
  [103.638, 1.35046], [103.66, 1.38526], [103.662, 1.40553], [103.673, 1.41379],
  [103.674, 1.42518], [103.717, 1.45054], [103.729, 1.45075], [103.737, 1.43873],
  [103.743, 1.43871], [103.744, 1.44629], [103.767, 1.44418], [103.769, 1.45249],
  [103.771, 1.44849], [103.809, 1.47057], [103.821, 1.46924], [103.823, 1.46102],
  [103.828, 1.46859], [103.834, 1.46471], [103.833, 1.45996], [103.837, 1.46481],
  [103.858, 1.45486], [103.855, 1.45249], [103.865, 1.43372], [103.858, 1.42653],
  [103.864, 1.42382], [103.879, 1.43176], [103.897, 1.42062], [103.898, 1.41473],
  [103.913, 1.42111], [103.93, 1.3997], [103.937, 1.40181], [103.941, 1.39776],
  [103.936, 1.39339], [103.941, 1.39524], [103.949, 1.38299], [103.967, 1.38086],
  [103.982, 1.39372], [103.997, 1.39029], [104.007, 1.37396], [104.008, 1.38163],
  [104.044, 1.35259], [104.06, 1.32599], [104.033, 1.32407], [104.033, 1.31618],
  [104.023, 1.32021], [104.012, 1.30948], [103.984, 1.31202], [103.984, 1.31666],
  [103.963, 1.31468], [103.893, 1.29357], [103.871, 1.28049], [103.861, 1.2647],
  [103.852, 1.26811], [103.851, 1.26073], [103.846, 1.26684], [103.846, 1.26154],
  [103.832, 1.26741], [103.824, 1.26308], [103.836, 1.26385], [103.842, 1.2579],
  [103.836, 1.25481], [103.824, 1.26016], [103.825, 1.25527], [103.848, 1.25211],
  [103.833, 1.23781], [103.807, 1.25947], [103.822, 1.25827], [103.823, 1.26307],
  [103.811, 1.26258], [103.815, 1.26451], [103.812, 1.26644], [103.805, 1.2623],
  [103.794, 1.26921], [103.786, 1.25501], [103.779, 1.25918], [103.787, 1.27279],
  [103.777, 1.27867], [103.771, 1.26824], [103.75, 1.28049], [103.756, 1.28585],
  [103.769, 1.27831], [103.772, 1.28365], [103.761, 1.2906], [103.759, 1.29929],
  [103.728, 1.30004], [103.712, 1.30844], [103.723, 1.29967], [103.712, 1.29961],
  [103.714, 1.29124]
]

export const UBIN = [
  [103.934, 1.4281], [103.946, 1.42387], [103.948, 1.42263], [103.949, 1.42036],
  [103.953, 1.41868], [103.955, 1.41908], [103.956, 1.4177], [103.961, 1.41766],
  [103.97, 1.41969], [103.979, 1.41763], [103.984, 1.41789], [103.986, 1.41911],
  [103.995, 1.41906], [103.999, 1.41525], [104.003, 1.40365], [104.002, 1.4028],
  [103.996, 1.40406], [103.989, 1.4041], [103.988, 1.40273], [103.987, 1.40411],
  [103.978, 1.40417], [103.975, 1.40247], [103.973, 1.40347], [103.968, 1.40112],
  [103.958, 1.39946], [103.955, 1.4049], [103.953, 1.40578], [103.95, 1.40556],
  [103.949, 1.40995], [103.934, 1.41566], [103.934, 1.41723], [103.931, 1.41718],
  [103.928, 1.41899], [103.927, 1.42183], [103.926, 1.42238], [103.926, 1.42365],
  [103.929, 1.42433], [103.934, 1.4281]
]

export const TEKONG = [
  [104.055, 1.43161], [104.07, 1.42709], [104.081, 1.41899], [104.085, 1.41014],
  [104.084, 1.40718], [104.088, 1.40393], [104.088, 1.39622], [104.08, 1.38115],
  [104.075, 1.36308], [104.076, 1.35482], [104.084, 1.34052], [104.083, 1.33761],
  [104.081, 1.33804], [104.022, 1.38873], [104.016, 1.40123], [104.029, 1.40314],
  [104.03, 1.40471], [104.028, 1.40812], [104.03, 1.4114], [104.027, 1.41195],
  [104.022, 1.40863], [104.014, 1.409], [104.012, 1.41081], [104.009, 1.41883],
  [104.01, 1.42545], [104.021, 1.4354], [104.036, 1.44036], [104.043, 1.4398],
  [104.047, 1.43504], [104.054, 1.43376], [104.055, 1.43161]
]
